import { render } from "./PlaceholderElement.vue?vue&type=template&id=a59aca88"
import script from "./PlaceholderElement.vue?vue&type=script&lang=js"
export * from "./PlaceholderElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__